import { Component, ComponentRef, Input, OnDestroy } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { CustomViewService } from "./customViewService";
import { CustomViewConfig, CustomViewItem, ICustomViewComponent } from "./interfaces";

@Component({
    selector: "custom-view",
    template: `<ng-template [customViewHost]="configObservable" (customComponent)="onCustomComponent($event)"></ng-template>`,
    standalone: false
})
export class CustomViewComponent<TConfig = unknown> implements OnDestroy
{
    private readonly _configSubject = new BehaviorSubject<CustomViewConfig<TConfig>>(null);
    private _componentView: CustomViewItem<TConfig>;
    private _customDataBinding: TConfig;
    protected _customComponent: ComponentRef<ICustomViewComponent<TConfig>>;

    @Input()
    set customDataBinding(value: TConfig)
    {
        if (this._customDataBinding === value)
        {
            return;
        }

        this._customDataBinding = value;

        this._configSubject.next({
            customView: this._componentView,
            data: this._customDataBinding
        });
    }

    @Input()
    set component(value: string)
    {
        if (this._componentView === this.customViewService.getView<TConfig>(value))
        {
            return;
        }

        this._componentView = this.customViewService.getView<TConfig>(value);

        this._configSubject.next({
            customView: this._componentView,
            data: this._customDataBinding
        });
    }

    constructor(
        private customViewService: CustomViewService)
    { }

    /**
     * @private For use in the template, not intended for any other API.
     */
    get configObservable(): Observable<CustomViewConfig<TConfig>> { return this._configSubject.asObservable(); }

    /**
     * Returns a ComponentRef with an instance of the custom component.
     */
    get customComponent(): ComponentRef<ICustomViewComponent<TConfig>> { return this._customComponent; }

    ngOnDestroy(): void
    {
        this._configSubject.complete();
    }

    onCustomComponent($event: ComponentRef<ICustomViewComponent<TConfig>>): void
    {
        this._customComponent = $event;
    }
}
